/**
 * About Us page — English (nested for t('aboutUs.…'), shared by m & pc)
 */
export default {
	meta: {
		breadcrumb: "About Us",
		title: "About Us - Plan Your Life, Live with Ease (See Beyond)",
		keywords:
			"SeerQ,About Us,fortune telling platform,BaZi reading,divination services,brand philosophy",
		description:
			"SeerQ is a global cultural content platform that brings together wisdom from experts worldwide, integrating Eastern metaphysics, Western divination, and mind-body healing to deliver precise, personalized professional services.",
		ogTitle: "About Us - Plan Your Life, Live with Ease (See Beyond)",
		ogDescription:
			"SeerQ is a global cultural content platform offering BaZi, horoscope, tarot, divination, and personalized life guidance services.",
	},
	hero: {
		ariaLabel: "Brand Banner",
		slogan: "",
	},
	brandPhilosophy: {
		ariaLabel: "Brand Philosophy",
		title: "Brand Philosophy",
		subtitle:
			"A global life-mentor digital platform that helps you plan your life and live more simply",
		desc: "SeerQ, headquartered in Hong Kong, is a leading global digital marketplace for life mentors. Powered by AI and digital technology, our SaaS platform connects users facing life decisions who need private, professional support with quality mentor institutions worldwide. Through review systems, escrow services, standardized processes, and efficient operating tools, we protect both sides and support users on their growth journey toward our core vision: See Beyond — making life easier. With online and offline services across regions and cultures, SeerQ aims to become a benchmark digital ecosystem in global personal growth.",
		stats: [
			{ value: "2,000,000+", label: "Global Users" },
			{ value: "200+", label: "Professional Mentors" },
			{ value: "99%", label: "Satisfaction" },
		],
	},
	newsRelease: {
		ariaLabel: "Press Releases",
		title: "Press Releases",
		subtitle: "Stay updated on SeerQ news, milestones, and developments",
		tag: "Product Launch",
		viewNewsAria: "View news: {title}",
		paginationAria: "Press release pagination",
		prevPage: "Previous page",
		nextPage: "Next page",
	},
	business: {
		ariaLabel: "Business Cooperation",
		title: "Business Cooperation",
		subtitle: "Partner with us to create shared value",
		offices: [
			{
				title: "Hong Kong Group Headquarters",
				contacts: [
					{
						icon: "location",
						text: "Room 2003, COFCO Building, 262 Gloucester Road,Causeway Bay, Hong Kong Special Administrative Region",
					},
					{ icon: "phone", text: "Tel: +852 2808 1038" },
					{ icon: "mobile", text: "Mobile: +852 5325 7739" },
					{ icon: "email", text: "Email: zhanglin{'@'}seeronnet.com" },
				],
			},
			{
				title: "Taiwan Agency: Hong Kong Baozheng Co., Ltd. Taiwan Branch",
				contacts: [
					{
						icon: "location",
						text: "4F, No. 57, Section 4, Xinyi Road, Da'an District, Taipei City, Taiwan",
					},
					{ icon: "phone", text: "Service Hotline: +886 979-060-268" },
					{
						icon: "time",
						text: "Business Hours: Mon–Fri 09:00–18:00 (Closed on weekends and public holidays)",
					},
				],
			},
			{
				title: "Malaysia Branch",
				contacts: [
					{
						icon: "location",
						text: "Suite A-09-06, Level 9, Menara UOA Bangsar No.5, Jalan Bangsar Utama 1, 59000 Kuala Lumpur",
					},
					{ icon: "email", text: "Email: tarry{'@'}seeronnet.com" },
					{ icon: "whatsapp", text: "WhatsApp: +852 5749 8414" },
				],
			},
		],
	},
	cooperativeMedia: {
		ariaLabel: "Media Partners",
		title: "Media Partners",
		subtitle: "Partnering with quality media to create value and expand our reach",
		groups: [
			{ title: "TV & Broadcast", subtitle: "Premium television media partners" },
			{ title: "TV Media Platforms", subtitle: "Popular television media platforms" },
			{ title: "Omnichannel New Media", subtitle: "Diverse social media partners" },
			{ title: "Print & Online Media", subtitle: "Professional news media partners" },
		],
	},
	download: {
		ariaLabel: "Download App",
		title: "Ready to explore your life direction?",
		desc: "Download the SeerQ app now and begin your journey of wisdom",
		googlePlayAria: "Download from Google Play",
		appStoreAria: "Download from App Store",
		apkAria: "Download APK directly",
		storeLabel: "Download On The",
		googlePlayName: "Google Play",
		appStoreName: "App Store",
		apkLabel: "Download APK",
		apkName: "Android Apk",
	},
};
